module.exports = __webpack_public_path__ + "img/levelup_icon_investment.53261a36.svg";